import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';

import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import Loader from '../../Common/Loader/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import { removeStaticBannerImage } from '../../../actions/siteadmin/PrecautionNotification/updatePrecautionNotification';
import { updatePrecautionNotificationImage } from '../../../actions/siteadmin/PrecautionNotification/updatePrecautionNotificationImage';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { demoRestriction } from '../../../actions/demoRestriction';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';
import { api, staticpageUploadDir } from '../../../config';

import bt from '../../../components/commonStyle.css';
import s from './PrecautionNotificationForm.css';


const RenderQuill = ({ input, meta: { touched, error } }) => {
  const intl = useIntl();
  const [Editor, setEditor] = useState(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('../../Common/Editor/CustomEditor').then(mod => setEditor(() => mod.Editor));
    }
  }, []);
  return (
    Editor &&
    <div>
      <Editor
        {...input}
      />
      {touched && error && <span className={bt.errorMessage}>{intl.formatMessage(error)}</span>}
    </div>
  )
}

const PrecautionNotificationForm = (props) => {
  const {
    handleSubmit,
    imageName,
    precautionImageLoader,
    loading,
    submitting,
    change,
    id,
    removeStaticBannerImage,
    updateTempImages,
    intl: { formatMessage },
    demoRestriction
  } = props;

  const [isClient, setClient] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setClient(true)
    }
  }, []);

  const success = async (file, fromServer) => {
    let oldImage = imageName;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await change('imageName', fromServer?.fileName);
    if (id) {
      updatePrecautionNotificationImage({ id, imageName: fromServer.fileName }, oldImage);
    } else {
      await updateTempImages('PrecautionNotification', 'imageName', fromServer?.fileName);
      if (oldImage) await removeStaticBannerImage(oldImage);
    }
  };

  const notificationStatus = [
    { value: true, label: formatMessage(messages.Enabled) },
    { value: false, label: formatMessage(messages.Disabled) }
  ]

  return (
    isClient ? <div>
      <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
        <div className={cx(bt.space4, s.paddingTop, s.singleCard)}>
          <div className={cx(s.profileImgSection)}>
            <label className={bt.commonLabelText}>{formatMessage(messages.image)}</label>
            <CommonImageDisplay loader={precautionImageLoader} imageSrc={imageName ? api.apiEndpoint + staticpageUploadDir + 'large_' + imageName : null} />

            <ImageUploadComponent
              className='commonSiteAdminDropzoneSpace'
              subText={formatMessage(messages.maximumUploadSizeLabel)}
              defaultMessage={formatMessage(messages.chooseFile)}
              componentConfig={{
                iconFiletypes: ['.jpg', '.png', '.svg'],
                multiple: false,
                showFiletypeIcon: false,
                postUrl: api.apiEndpoint + '/uploadStaticBannerImage'
              }}
              success={success}
              loaderName={'precautionImageLoader'}
            />
          </div>
        </div>

        <div className='oneColumnGrid'>
          <div className='twoColumnGrid'>
            <Field
              name="title"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.title)}
              placeholder={formatMessage(messages.title)}
              inputClass={bt.formControlInput} />

            <Field
              name="isEnabled"
              component={SelectFieldComponent}
              label={formatMessage(messages.status)}
              options={notificationStatus}
              inputClass={bt.formControlSelect}
            />
          </div>

          <div className='quillBox'>
            <label className={bt.commonLabelText}><FormattedMessage {...messages.description} /></label>
            <Field name="description" component={RenderQuill} />
          </div>
        </div>

        <div className='commonButtonContainer'>
          <Loader
            type="button"
            label={formatMessage(messages.submitButton)}
            show={loading}
            buttonType="submit"
            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
            disabled={submitting || loading}
          />
        </div>
      </Form>
    </div>
      : <div></div>
  );
};

const selector = formValueSelector('PrecautionNotificationForm');

const mapState = (state) => ({
  id: selector(state, 'id'),
  title: selector(state, 'title'),
  description: selector(state, 'description'),
  isEnabled: selector(state, 'isEnabled'),
  imageName: selector(state, 'imageName'),
  precautionImageLoader: state?.loader?.precautionImageLoader,
  loading: state.loader.PrecautionNotificationForm
});

const mapDispatch = {
  change,
  updateTempImages,
  removeStaticBannerImage,
  demoRestriction
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(reduxForm({
  form: 'PrecautionNotificationForm',
  validate
})(PrecautionNotificationForm))));
